import { useState } from 'react';

import {
    UpdateUserConsentsDocument,
    UpdateUserConsentsMutation,
    UpdateUserConsentsMutationVariables
} from '../queries/updateUserConsents.generated';

import { UpdateUserConsentsInput } from '../../../graphql.generated';
import { useLazyFetchGraphql } from '@zoopla/fetch-graphql';

type PreferencesFormData = {
    consent__insights__24: boolean;
};

export const useUpdatePreferences = (onSuccess?: () => void) => {
    const [generalError, setGeneralError] = useState(false);

    const { lazyFetch } = useLazyFetchGraphql<
        UpdateUserConsentsMutation,
        UpdateUserConsentsMutationVariables
    >(UpdateUserConsentsDocument, {
        onCompleted({ updateUserConsents: response }) {
            if (!response) {
                setGeneralError(true);
                return;
            }
            onSuccess?.();
        },
        onError() {
            setGeneralError(true);
        }
    });

    const updatePreferences = (props: PreferencesFormData) => {
        setGeneralError(false);

        const { consent__insights__24 } = props;

        const input: UpdateUserConsentsInput = {
            consents: [
                {
                    id: 24,
                    agreed: consent__insights__24
                }
            ]
        };

        return lazyFetch({ input });
    };

    return {
        updatePreferences,
        generalError
    };
};
